import { Observable } from 'rxjs'
import { Action } from 'actions'
import { filter } from 'rxjs/operators'

export const byType = <
  ActionType extends Action['type'],
  FilteredAction extends Extract<Action, { type: ActionType }>
>
  (...actionTypes: ActionType[]) => (source: Observable<Action>): Observable<FilteredAction> => {
    return source.pipe(
      filter((action) => {
        for (const actionType of actionTypes) {
          if (actionType === action.type) {
            return true
          }
        }
        return false
      })
    ) as Observable<FilteredAction>
  }
